import {FC} from 'react'
import {SelectAsync2} from '../../SelectV2'

type Props = {
  keySelect?: string
  name: string
  disabled?: boolean
  required?: boolean
  loadOptions?: (inputValue: string) => Promise<{value: string; label: string}[]>
  value?: any
  labelText?: string
  onChangeValue?: (e: any) => void
  textPlaceholder?: string
  isClearable?: boolean
}

const SelectWrapper: FC<Props> = ({
  keySelect,
  name,
  disabled,
  required,
  labelText,
  onChangeValue,
  textPlaceholder,
  loadOptions,
  value,
  isClearable = true,
}) => {
  const classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <SelectAsync2
        keySelect={keySelect}
        name={name}
        disabled={disabled}
        onChangeValue={onChangeValue}
        textPlaceholder={textPlaceholder}
        loadOptions={loadOptions}
        value={value}
        isClearable={isClearable}
      />
    </div>
  )
}

export default SelectWrapper
